module.exports = __webpack_public_path__ + "img/videos_global-settings.7cb6e045.png";